// import useAbilitiesHelper from "@helpers/AbilitiesHelper"

export const MENU_TANK_SOUNDING = (ability) => {
  // const [isUserAllowed] = useAbilitiesHelper(ability);
  return [
    { name: 'Dashboard', url: '/tanksounding/dashboard', icon: 'flaticon-analytics', hasSubMenu: false, exactMenu: true },
    { name: 'Dashboard - Calendar', url: '/tanksounding/calendardashboard', icon: 'bi bi-calendar3', hasSubMenu: false, exactMenu: true },
    { name: 'Day Entry', url: '/tanksounding/dayentry', icon: 'bi bi-journal-plus', hasSubMenu: false, exactMenu: true },
    { name: 'Product Movement Slip', url: '/tanksounding/pms', icon: 'bi bi-receipt-cutoff', hasSubMenu: false, exactMenu: true },
    { name: 'Movements', url: '/tanksounding/movements', icon: 'fas fa-dolly', hasSubMenu: false, exactMenu: true },
    { name: 'Reports', url: '/tanksounding/reports', icon: 'bi-file-bar-graph', hasSubMenu: false, exactMenu: true },
    { name: 'Report Ledger', url: '/tanksounding/reportledger', icon: 'bi-table', hasSubMenu: false, exactMenu: true },
    { name: 'Inventory Summary', url: '/tanksounding/inventorysummary', icon: 'flaticon-list-2', hasSubMenu: false, exactMenu: true },
    {
      name: 'Maintenance', url: 'maintenance', icon: 'bi bi-gear menu-icon', hasSubMenu: true, exactMenu: false,
      submenu: [
        { name: 'Tanks', url: '/tanksounding/maintenance/tanks', hasSubMenu: false, exactMenu: true },
        { name: 'Fractional', url: '/tanksounding/maintenance/fractional', hasSubMenu: false, exactMenu: true },
        { name: 'Height', url: '/tanksounding/maintenance/height', hasSubMenu: false, exactMenu: true },
        { name: 'SG', url: '/tanksounding/maintenance/sg', hasSubMenu: false, exactMenu: true },
      ]
    },
  ]
}